import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import useDevice, { devices } from '../hooks/useDevice';
import { mapContextToProps } from './OlsShopContext';

function DeviceText(props) {
  const { Details, Block } = UX2.Element;
  const { children, viewDevice, ...rest } = props;
  const [device] = useDevice();
  const isDesktopDevice = devices.DESKTOP === device;
  const isDesktopRender = viewDevice !== 'MOBILE_RENDER_DEVICE';

  if (viewDevice ? isDesktopDevice && isDesktopRender : isDesktopDevice) {
    return (
      <Block tag='span' { ...rest }>
        { children }
      </Block>
    );
  }

  return <Details { ...rest }>{ children }</Details>;
}

DeviceText.propTypes = {
  children: PropTypes.node,
  viewDevice: PropTypes.string
};

export default mapContextToProps(DeviceText, context => ({
  viewDevice: context.viewDevice
}));
